/* eslint-disable camelcase */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-underscore-dangle */
import React, { Component } from "react";
import { I18n } from "react-redux-i18n";
import Select from "@alboompro/boom-components/data-entry/select";
import Icon from "@alboompro/boom-components/general/icon";
import FormBuilder from "@alboom/form-builder-react/form-builder/index";
import styled from "styled-components";
import { PropListItem } from "./styles";

const CustomPropListItem = styled(PropListItem)`
  user-select: none;
  position: relative;
  > div {
    width: 100%;
    margin: 0;
    padding: 0;

    > span {
      font-size: 12px;
    }

    > div {
      > div {
        > span {
          margin-left: 10px;
        }
      }
    }
    .form-element-list-select {
      div {
        padding: 0;
      }
    }
  }

  label {
    user-select: none;
  }
`;

const EditForm = styled.span`
  display: flex;
  align-items: center;
  font-size: 12px;
  cursor: pointer;
  position: absolute;
  top: 9px;
  right: 0;
  padding: 3px;
`;

const NewForm = styled.div`
  width: 100%;
  height: 100%;
  color: #44adf8;
  font-size: 12px;
  padding: 8px;

  display: flex;
  align-items: center;
  gap: 8px;
`;

const Option = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 8px;
  border-radius: 3px;
`;

class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      newForm: true,
    };
  }

  formatOptions = () => {
    const {
      editorData: { forms = [] },
    } = this.props;
    const opts = forms.map((form) => ({
      label: <Option>{form.name}</Option>,
      value: form._id,
    }));
    opts.push({
      value: "new_form",
      label: (
        <NewForm>
          <Icon
            kind="bold"
            group="interface-essential"
            category="remove-add"
            file="add.svg"
            size="14"
            color="#44adf8"
          />
          {I18n.t("editPanel.form.createNewForm")}
        </NewForm>
      ),
      props: { onClick: () => this.onOpenModal("newForm") }
    });
    return opts;
  };

  handleChange = ({ value }) => {
    const { updaterFn, name } = this.props;
    if (value !== "new_form") {
      updaterFn({ prop: name, value });
      this.setState({ newForm: false })
    } else {
      this.setState({ newForm: true });
    }
  };

  onOpenModal = action => {
    this.setState({ visible: true, newForm: action === "newForm" });
  }

  onCloseModal = () => {
    this.setState({ visible: false, newForm: false });
  };

  handleUpdate = (newForm) => {
    const {
      name,
      currentValue,
      store,
      updaterFn,
      editorData: { forms },
    } = this.props;
    if (forms && forms.length) {
      const hasItem = forms.filter((form) => form._id === newForm._id);
      const newItems = hasItem.length
        ? forms.map((form) => (form._id === newForm._id ? newForm : form))
        : forms.concat(newForm);
      store.update({ success: true, forms: newItems });
    } else {
      store.update({ success: true, forms: [newForm] });
    }

    // trigger update function within element if the current
    // form is the one that was updated
    if (currentValue === newForm._id) {
      store.trigger("formUpdated", newForm);
    }

    updaterFn({ prop: name, value: newForm._id });
  };

  render() {
    const { visible, newForm } = this.state;
    const { label, locale, currentValue } = this.props;

    return (
      <CustomPropListItem>
        <Select
          label={label[locale]}
          value={currentValue}
          placeholder="Form"
          options={this.formatOptions()}
          onChange={this.handleChange}
          optionsStyle={{
            fontWeight: 400,
            padding: 0,
            height: 33,
            fontSize: 12,
            position: "relative"
          }}
          selectStyle={{
            backgroundColor: "#fff",
            padding: "8px 12px",
            height: 34,
            border: "1px solid #ebebeb",
            borderRadius: "3px",
            fontSize: 12,
            lineHeight: 1.5,
          }}
          selectClassName="form-element-list-select"
          dropdownStyle={{
            borderRadius: "3px",
            transform: "translateY(3px)",
            border: "1px solid #ebebeb",
            padding: 4,
          }}
          dropdownClassName="form-element-list-dropdown"
        />
        <EditForm className="edit-form-btn" onClick={this.onOpenModal}>
          <Icon
            kind="light"
            group="interface-essential"
            category="edit"
            file="pencil-1.svg"
            size="12"
            color="#3E3E3E"
          />
        </EditForm>

        <FormBuilder
          visible={visible}
          onClose={this.onCloseModal}
          onUpdate={this.handleUpdate}
          idForm={newForm ? "" : currentValue}
          language={locale}
        />
      </CustomPropListItem>
    );
  }
}

export default Form;
